import { useForm, Controller } from 'react-hook-form';
import { BLOCKED_OR_NOT, CLASSNAMES, ROLES } from 'admin/utils/contants';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import {
  ModalWrapper,
  ModalSampleField,
  SaveButton,
  StyledSelect,
  CloseIcon,
  InputWithLabel,
} from './styled';
import { Images } from 'assets/images';

export const EditUserModal = ({ changeData, setIsOpen }) => {
  const { handleSubmit, register, control } = useForm();

  const onSubmit = (userEditedValue) =>
    console.log('edited user info', userEditedValue);

  return (
    <ModalWrapper onSubmit={handleSubmit(onSubmit)}>
      <CloseIcon src={Images.adminCloseIcon} onClick={() => setIsOpen(false)} />
      <ModalSampleField>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <>
              <InputWithLabel
                id="outlined-basic"
                label="Name"
                {...register('name')}
                onChange={(e) => field.onChange(e)}
                key={field.key}
                variant="outlined"
                value={changeData.name}
              />
            </>
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <Controller
          control={control}
          name="blocked"
          render={({ field }) => (
            <Box>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Blocked</InputLabel>
                <StyledSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Blocked"
                  onChange={field.onChange}
                  selected={field.value}
                  value={changeData.blocked}
                  options={BLOCKED_OR_NOT}
                  placeholder="Blocked"
                >
                  <MenuItem value={CLASSNAMES.BLOCKED}>Yes</MenuItem>
                  <MenuItem value={CLASSNAMES.NOT_BLOCKED}>No</MenuItem>
                </StyledSelect>
              </FormControl>
            </Box>
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <Controller
          control={control}
          name="blocked"
          render={({ field }) => (
            <Box>
              <FormControl disabled>
                <InputLabel id="demo-simple-select-label">Role</InputLabel>
                <StyledSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Role"
                  onChange={field.onChange}
                  selected={field.value}
                  value={changeData.role}
                  options={BLOCKED_OR_NOT}
                  placeholder="Role"
                >
                  <MenuItem value={ROLES.user}>{ROLES.user}</MenuItem>
                  <MenuItem value={ROLES.admin}>{ROLES.admin}</MenuItem>
                  <MenuItem value={ROLES.operator}>{ROLES.operator}</MenuItem>
                </StyledSelect>
              </FormControl>
            </Box>
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <Controller
          name="request_limit"
          control={control}
          render={({ field }) => (
            <>
              <InputWithLabel
                id="outlined-basic"
                label="Request Limit"
                {...register('request_limit')}
                onChange={(e) => field.onChange(e)}
                key={field.key}
                variant="outlined"
                type="number"
                value={changeData?.request_limit}
              />
            </>
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <SaveButton>Save</SaveButton>
      </ModalSampleField>
    </ModalWrapper>
  );
};
